import { z } from "zod";

export const schema = z.object({
    agree: z.boolean().refine((val) => val, {
        message: 'You have to agree to the terms and conditions to continue.',
    })
})
